import classnames from 'classnames';
import { CKContainerProps } from 'clearkit';

export const CarouselCardWrapper = ({
  children,
  className,
  ...rest
}: CKContainerProps) => (
  <div {...rest} className={classnames(className, 'shrink-0')}>
    {children}
  </div>
);
